import { AuditLog, LogName, LogType } from '@oxappsec/ox-unified-audit-logger';
import { Nullable } from 'common-types';
import { FilterElements } from '../../common/filters-utils/filters-utils';

export enum AuditLogsError {
  FailedLoadAuditLogs = 'Failed to load audit logs, please try again later',
  FailedLoadAuditLogFilters = 'Failed to load audit log filters, please try again later',
}

export interface GetLogsInput {
  dateRange?: DateRange;
  limit: number;
  skip: number;
  orderBy: OrderBy;
  logTypes: Nullable<LogType[]>;
  logNames: Nullable<LogName[]>;
  userEmails: Nullable<string[]>;
}

export interface AuditLogsResponse {
  auditLogs: AuditLog[];
  logsCount?: number;
}

export interface DateRange {
  from: Date;
  to: Date;
}

export interface OrderBy {
  direction: Direction;
  field: string;
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}
export interface AuditLogFilters {
  logTypes: FilterElements[];
  logNames: FilterElements[];
  userEmails: FilterElements[];
  total: number;
}
